import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-chart-search')
export class ObiChartSearch extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.8284 12.0147C22.3905 13.5768 22.3905 16.1095 20.8284 17.6716C19.5105 18.9895 17.5017 19.1955 15.9678 18.2896L13.4038 20.8536C13.2085 21.0488 12.892 21.0488 12.6967 20.8536L11.9896 20.1464C11.7943 19.9512 11.7943 19.6346 11.9896 19.4393L14.5536 16.8754C13.6476 15.3415 13.8536 13.3327 15.1716 12.0147C16.7337 10.4526 19.2663 10.4526 20.8284 12.0147ZM17.9904 17.2745C19.3711 17.2745 20.4904 16.1553 20.4904 14.7745C20.4904 13.3938 19.3711 12.2745 17.9904 12.2745C16.6097 12.2745 15.4904 13.3938 15.4904 14.7745C15.4904 16.1553 16.6097 17.2745 17.9904 17.2745Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M22 4.3V10.9378C21.5285 10.4358 20.9637 10.0223 20.3333 9.72503V5.15L16.3889 6.5V9.43915C15.7823 9.62347 15.2201 9.90979 14.7222 10.2781V6.5L9.27778 4.85V17.475L11.2327 18.0674L10.0785 19.2216L8.36111 18.675L3.38889 20.45C3.07407 20.6 2.76389 20.5917 2.45833 20.425C2.15278 20.2583 2 20.0083 2 19.675V5.725C2 5.50833 2.06944 5.31667 2.20833 5.15C2.34722 4.98333 2.52778 4.85833 2.75 4.775L8.36111 3L15.6667 5.3L20.6111 3.525C20.9259 3.39167 21.2361 3.40417 21.5417 3.5625C21.8472 3.72083 22 3.96667 22 4.3ZM3.66667 18.825L7.61111 17.475V4.85L3.66667 6.025V18.825Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.8284 12.0147C22.3905 13.5768 22.3905 16.1095 20.8284 17.6716C19.5105 18.9895 17.5017 19.1955 15.9678 18.2896L13.4038 20.8536C13.2085 21.0488 12.892 21.0488 12.6967 20.8536L11.9896 20.1464C11.7943 19.9512 11.7943 19.6346 11.9896 19.4393L14.5536 16.8754C13.6476 15.3415 13.8536 13.3327 15.1716 12.0147C16.7337 10.4526 19.2663 10.4526 20.8284 12.0147ZM17.9904 17.2745C19.3711 17.2745 20.4904 16.1553 20.4904 14.7745C20.4904 13.3938 19.3711 12.2745 17.9904 12.2745C16.6097 12.2745 15.4904 13.3938 15.4904 14.7745C15.4904 16.1553 16.6097 17.2745 17.9904 17.2745Z" style="fill: var(--element-active-color)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M22 4.3V10.9378C21.5285 10.4358 20.9637 10.0223 20.3333 9.72503V5.15L16.3889 6.5V9.43915C15.7823 9.62347 15.2201 9.90979 14.7222 10.2781V6.5L9.27778 4.85V17.475L11.2327 18.0674L10.0785 19.2216L8.36111 18.675L3.38889 20.45C3.07407 20.6 2.76389 20.5917 2.45833 20.425C2.15278 20.2583 2 20.0083 2 19.675V5.725C2 5.50833 2.06944 5.31667 2.20833 5.15C2.34722 4.98333 2.52778 4.85833 2.75 4.775L8.36111 3L15.6667 5.3L20.6111 3.525C20.9259 3.39167 21.2361 3.40417 21.5417 3.5625C21.8472 3.72083 22 3.96667 22 4.3ZM3.66667 18.825L7.61111 17.475V4.85L3.66667 6.025V18.825Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-chart-search': ObiChartSearch;
  }
}
